import { Component } from '@angular/core';

@Component({
  selector: 'ngshop-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {}
